<template>
  <div class="flex items-center text-sm text-slate-500" style="gap: 12px">
    <span class="text-slate-400 font-normal text-sm">Sort by:</span>
    <span class="text-slate-800 font-bold text-sm">{{ label }}</span>
    <div ref="containerRef" class="relative">
      <button
        type="button"
        class="h-10 px-4 rounded border border-[#CBD5E1] text-sm font-semibold text-[#475569] flex items-center gap-2 bg-white hover:border-[#94A3B8] focus:outline-none focus:border-[#3B82F6]"
        @click="toggleDropdown"
      >
        <span>{{ selectedOption ? selectedOption.label : placeholder }}</span>
        <span class="rotate-90 ml-2">
          <Icon icon-name="dropdownArrow" svgFill="fill-slate-800" />
        </span>
      </button>

      <div
        v-if="isOpen"
        class="absolute right-0 top-full z-50 mt-2 rounded-lg border border-slate-200 bg-white shadow-lg"
        style="width: 180px"
      >
        <ul style="padding: 8px 0">
          <li
            v-for="option in options"
            :key="option.value"
            class="text-left text-sm text-slate-700 hover:bg-slate-50"
            style="padding: 8px 12px"
          >
            <button
              type="button"
              class="flex w-full items-center justify-between rounded px-2 py-1 text-left transition-colors focus:outline-none focus-visible:outline-none focus:ring-0"
              :class="option.value === modelValue ? 'bg-blue-50 text-blue-600 font-medium' : 'text-slate-700'"
              @click="selectOption(option.value)"
            >
              <span>{{ option.label }}</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from './Icon.vue';

export default {
  name: 'SortDropdown',

  components: {
    Icon
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    modelValue: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Select option'
    }
  },

  data() {
    return {
      isOpen: false,
      containerRef: null
    };
  },

  computed: {
    selectedOption() {
      return this.modelValue ? this.options.find((option) => option.value === this.modelValue) : undefined;
    }
  },

  mounted() {
    this.containerRef = this.$refs.containerRef;
    document.addEventListener('click', this.handleDocumentClick);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },

    selectOption(value) {
      this.$emit('update:model-value', value);
      this.isOpen = false;
    },

    handleDocumentClick(event) {
      if (!this.isOpen) {
        return;
      }

      const target = event.target;

      if (this.containerRef && target && this.containerRef.contains(target)) {
        return;
      }

      this.isOpen = false;
    }
  }
};
</script>
